// @ts-nocheck
/* eslint-disable */
import { node } from "~/util/dom";
import { setItem } from "~/es6/localstorage";
import { CONFIG } from "~/config";
import { _ } from "~/i18n";
import Scene from "~/scene";
import { store } from "~/state/store";
import { setMapset, setCoordinates } from "~/state/map/state";

Mapy.Egg = function(sceneControl, options) {
	SMap.Control.Visible.call(this);

	this._options = Object.assign({
		className: "cesko",
		text: _("close"),
		mapset: "zakladni",
		storageName: "april",
		czArea: false,
		zoomRange: null
	}, options);

	this._sceneControl = sceneControl;
	this._dom.container = node("div", { className: "map-control " + this._options.className });
	this._dom.btn = node("button", {innerHTML: "<span>" + this._options.text + "</span>"});
	this._dom.btn.setAttribute("type", "button");
	this._dom.btn.addEventListener("click", this, false);

	!CONFIG.inFrame && this._dom.container.appendChild(this._dom.btn);

	const mapState = store.getState().map;
	const { longitude, latitude, zoom } = mapState;
	this._prevMapset = { ...mapState };

	if (this._prevMapset && this._prevMapset.mapset == this._options.mapset) {
		this._prevMapset = null;
	} else {
		store.dispatch(setMapset({ mapset: this._options.mapset }));
	}

	var zoomRange = [8, 10];
	if (this._options.zoomRange && Array.isArray(this._options.zoomRange) && this._options.zoomRange.length === 2) {
		zoomRange = this._options.zoomRange;
	}

	if (this._options.czArea) {
		var area = Mapy.getComponent("statearea").lastCheck();
		if (area["cs"] && area["cs"].find) {
			store.dispatch(setCoordinates({
				longitude,
				latitude,
				zoom: Math.max(zoomRange[0], Math.min(zoomRange[1], zoom)),
				animate: true,
			}));
		} else {
			store.dispatch(setCoordinates({
				longitude: CONFIG.map.x,
				latitude: CONFIG.map.y,
				zoom: zoomRange[0],
				animate: true,
			}));
		}
	}
	if (this._options.zoomRange) {
		Scene.setZoomRange(zoomRange[0], zoomRange[1]);
	}
};

Mapy.Egg.prototype = Object.create(Object.assign({}, SMap.Control.prototype, SMap.Control.Visible.prototype));

Mapy.Egg.prototype.$destructor = function() {
	this._dom.btn.removeEventListener("click", this, false);
	SMap.Control.Visible.prototype.$destructor.call(this);
};

Mapy.Egg.prototype.getContainer = function() {
	return this._dom.container;
};

Mapy.Egg.prototype.handleEvent = function(e) {
	if (e.currentTarget == this._dom.btn) {
		this.close();
		Mapy.getComponent("history").save();
	}
};

Mapy.Egg.prototype.close = function(e) {
	setItem(this._options.storageName, "1");
	Scene.removeControl(this._sceneControl);
	store.dispatch(setMapset(this._prevMapset || { mapset: "zakladni" }));
	this._options.close(true, true);
};
